"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconPlaybackSpeed1Point7x = Experimental__IconPlaybackSpeed1Point7x;
exports.IconPlaybackSpeed1Point7x = IconPlaybackSpeed1Point7x;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconPlaybackSpeed1Point7x/index.tsx)
 */
function IconPlaybackSpeed1Point7x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m13.34 12.5 1.969-1.97-1.06-1.06-1.97 1.97-1.97-1.97-1.06 1.06 1.969 1.97-1.97 1.97 1.06 1.06 1.97-1.97 1.97 1.97 1.06-1.06-1.969-1.97Zm-2-4.5a7.996 7.996 0 0 1 .39-2.15 9.975 9.975 0 0 1 .91-2.05 8.343 8.343 0 0 1 1.23-1.63h-2.62v.97H9.96V.9h5.34v1.31a8.26 8.26 0 0 0-1.61 2.55c-.4.973-.62 2.053-.66 3.24h-1.69Zm-2.208.1a.976.976 0 0 1-.46-.11 1.015 1.015 0 0 1-.34-.31.84.84 0 0 1-.12-.44c0-.16.04-.303.12-.43a.924.924 0 0 1 .34-.3.91.91 0 0 1 .46-.12c.167 0 .32.04.46.12a.84.84 0 0 1 .33.3c.08.127.12.27.12.43 0 .153-.04.297-.12.43a.895.895 0 0 1-.33.32.976.976 0 0 1-.46.11Zm-3.435-5h-1.72V2.07c.627-.04 1.084-.153 1.37-.34.287-.187.467-.463.54-.83h1.26V8h-1.45V3.1Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m19.5 19.14 2.542-2.543-1.414-1.414-2.543 2.543-2.543-2.543-1.414 1.414 2.543 2.543-2.543 2.543 1.414 1.414 2.543-2.543 2.543 2.543 1.414-1.414L19.5 19.14Zm-3.564-6.773c.043-1.152.25-2.32.624-3.504a16.636 16.636 0 0 1 1.456-3.328c.598-1.034 1.259-1.93 1.984-2.688h-4.432V4.4h-1.856V1.007h8.352v1.888c-1.088 1.184-1.962 2.582-2.624 4.192-.661 1.611-1.024 3.371-1.088 5.28h-2.416Zm-3.52.16c-.245 0-.475-.053-.688-.16a1.434 1.434 0 0 1-.512-.464 1.317 1.317 0 0 1-.176-.672c0-.234.059-.448.176-.64.128-.192.299-.341.512-.448a1.409 1.409 0 0 1 1.36 0c.203.107.363.256.48.448.128.192.192.406.192.64 0 .235-.064.454-.192.656a1.294 1.294 0 0 1-.48.48 1.42 1.42 0 0 1-.672.16ZM7.14 4.351H4.388V2.895c.992-.064 1.712-.245 2.16-.544.46-.309.742-.757.848-1.344h1.808v11.36H7.14V4.351Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed1Point7x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point7x instead.
 */
function Experimental__IconPlaybackSpeed1Point7x(props) {
  return /*#__PURE__*/_react["default"].createElement(IconPlaybackSpeed1Point7x, props);
}